import { createBlueprint as t } from "@made-people/blueprint";
const e = t({
  slots: {
    base: "text-body-xs lg:text-body-sm leading-normal",
    // Tag Slots
    ul: "list-[disc] pl-8",
    ol: "list-[decimal-leading-zero] pl-8",
    li: "",
    span: "",
    p: "",
    h1: "",
    h2: "",
    h3: "",
    h4: "",
    h5: "",
    h6: "",
    blockquote: "",
    hr: "",
    a: "",
    strong: "",
    em: "",
    code: "",
    img: "",
    table: "",
    thead: "",
    tbody: "",
    tr: "",
    th: "",
    td: "",
    pre: ""
  },
  variants: {}
}), l = t({
  slots: {
    wrapper: "flex flex-col gap-4 max-w-[800px] mx-auto my-component-y-spacing-lg lg:my-component-y-spacing-3xl",
    author: "text-heading-2xs [&>span]:italic",
    published: "text-heading-2xs [&>span]:italic",
    headerWrapper: "flex flex-col gap-2"
  },
  variants: {}
}), o = {
  main: l,
  markdown: e.clone()
};
export {
  o as blogPostBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
